import SingleFileupload from '@/components/common/fileupload/single/SingleFileupload.vue'

const defaultEl = {
  id: null,
  title: '',
  locale: null,
  document_type: null
}
export default {
  name: 'Fileupload',
  props: ['value', 'disabled', 'changelocale', 'includeDoctype', 'validatorRes', 'hideTitle', 'singleline'],
  data () {
    return {
      content: (this.value === null) ? [] : this.value,
      selectedLocale: null
    };
  },
  components: {
    SingleFileupload
  },
  methods: {
    updateValue (key, content) {
      this.content[key] = content;
      this.$emit('input', this.content);
    },
    deleteItem (idx) {
      if (this.content[idx].id) {
        this.content[idx].filename = 'DELETED';
        this.content[idx].deleted = true;
      } else {
        this.content.splice(idx, 1);
      }
      this.$forceUpdate();
      this.updateValue();
    },
    addItem (key) {
      this.content.push(this.BasicHelper.cloneObject(defaultEl));
      this.$forceUpdate();
      this.updateValue();
    },
    forceUpdate (key) {
      this.$refs.singlefileupload[key].$forceUpdate();
    }
  }
}
